import React, {FC} from 'react';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import { ImportExport } from '../../../components/Grossharvestofproducts/ImportExport';

const ImportExportPage: FC = () => {
    const {t} = useTranslation();

    return (
        <>
            <Helmet>
                <title>Экспорт/импорт</title>
            </Helmet>
            <ImportExport/>
        
        </>
    );
};

export default ImportExportPage
